// extracted by mini-css-extract-plugin
export var aggregationCell = "_2v-p";
export var aggregationRow = "_2v-o";
export var borderlessSpinnerContainer = "_2v-3";
export var cardLayout = "_2v-6";
export var cardLayoutNoFooter = "_2v-a";
export var cardLayoutPageControl = "_2v-9";
export var cardLayoutWithFooter = "_2v-8";
export var closeIcon = "_2v-h";
export var columnHeaderSurface = "_2v-d";
export var columnHeaderSurfaceDragOverlay = "_2v-x";
export var columnHeaderSurfaceResizing = "_2v-u";
export var contextMenuAnchor = "_2v-1";
export var draggableColumnHeader = "_2v-v";
export var draggableColumnHeaderOverlay = "_2v-w";
export var expandIcon = "_2v-i";
export var expanded = "_2v-j";
export var filterDropdown = "_2v-k";
export var filterDropdownDivider = "_2v-f";
export var filterDropdownHeader = "_2v-n";
export var filterDropdownItem = "_2v-m";
export var filterDropdownModal = "_2v-l _2v-k";
export var filterItem = "_2v-e";
export var normalCellWithAdjustableBorder = "_2v-g";
export var pinButtonContainer = "_2v-q";
export var pinIcon = "_2v-r";
export var pinIconActive = "_2v-s";
export var spinner = "_2v-0";
export var spinnerContainer = "_2v-2";
export var tableContainer = "_2v-4";
export var tableContentDraggingColumns = "_2v-c";
export var tableContentInner = "_2v-7";
export var tableContentInnerFill = "_2v-b";
export var tableContentWrapper = "_2v-5";
export var viewButtonContainer = "_2v-t";